<template>
  <div>
    <ul class="list-disc" v-for="(item, i) in ulList" :key="i">
      <li>
        {{ item.li }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["ulList"],
};
</script>